import { Graphics } from 'pixi.js';

interface SpinnerConfig {
  dotRadius: number;
  dotDistance: number;
  dotsNumber: number;
  dotColor: string;
}

const defaultConfig: SpinnerConfig = {
  dotRadius: 10,
  dotDistance: 30,
  dotsNumber: 8,
  dotColor: 'white',
};

export class LoadingSpinnerView extends Graphics {
  constructor(config: Partial<SpinnerConfig> = {}) {
    super();
    this.initSpinner({ ...defaultConfig, ...config });
  }

  private initSpinner(config: SpinnerConfig): void {
    const { dotRadius, dotsNumber, dotDistance, dotColor } = config;

    for (let i = 0; i < dotsNumber; i += 1) {
      const angle = (i / dotsNumber) * 2 * Math.PI;
      const x = Math.cos(angle) * dotDistance;
      const y = Math.sin(angle) * dotDistance;
      this.circle(x, y, dotRadius).fill({ color: dotColor, alpha: i / dotsNumber });
    }

    const interval = setInterval(() => {
      this.angle += 360 / dotsNumber;
    }, 100);
    this.on('destroyed', () => {
      clearInterval(interval);
    });
  }
}
